import { v4 as uuid_v4 } from "uuid";
export function ensureRequestID(req) {
    const id = req.headers["x-amz-cf-id"];
    if (id && typeof id === "string") {
        return id;
    }
    const newID = uuid_v4();
    req.headers["x-amz-cf-id"] = newID;
    return newID;
}
export function setRequestIDIfPresent(requestID, res) {
    if (requestID) {
        res.setHeader("x-request-id", requestID);
    }
}
export async function getRequestBody(req) {
    return new Promise((resolve, reject) => {
        let postBody = "";
        req.on("data", (data) => {
            // convert Buffer to string
            postBody += data.toString();
        });
        req.on("end", () => {
            resolve(postBody);
        });
        req.on("error", (err) => {
            reject(err);
        });
    });
}
